// Page-view tracking. Gated by the backend analytics toggle (AppSetting
// mixpanel_enabled, exposed as window.analyticsEnabled). Sends the same
// "Page View" event name used historically so it aligns with imported data.
function analyticsEnabled(): boolean {
  return Boolean(window.analyticsEnabled ?? window.mixpanelEnabled);
}

export function trackPageView() {
  if (!analyticsEnabled()) return;

  const pageInfo = {
    page_path: window.location.pathname,
    page_title: document.title,
    page_url: window.location.href,
    referrer: document.referrer,
    user_type: window.user ? 'authenticated' : 'anonymous',
    user_id: window.user?.firebase_user_id || null,
    // Rails controller/action info if available
    ...(window.pageTrackingData || {}),
  };

  window.posthog?.capture('Page View', pageInfo);
}

// Enhanced page tracking with controller/action info
export function trackRailsPageView(
  controller: string,
  action: string,
  additionalProps: Record<string, any> = {}
) {
  if (!analyticsEnabled()) return;

  const pageInfo = {
    page_path: window.location.pathname,
    page_title: document.title,
    page_url: window.location.href,
    referrer: document.referrer,
    controller,
    action,
    user_type: window.user ? 'authenticated' : 'anonymous',
    user_id: window.user?.firebase_user_id || null,
    ...additionalProps,
  };

  window.posthog?.capture('Page View', pageInfo);
}
